import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, ElementRef, NgZone, PLATFORM_ID, QueryList, Renderer2, DOCUMENT } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { FilterService, OverlayService, PrimeNGConfig } from 'prime-ng-old/api';
import { Table as TableBase } from 'prime-ng-old/table';
import { take } from 'rxjs';
import { UiMenuComponent } from '../menu';
import { UiTemplateDirective } from '../shared';
import { TableService } from './service';
import { PARENT_TABLE } from './table.injection-token';
import { FormsModule } from '@angular/forms';
import { InputNumberModule } from 'prime-ng-old/inputnumber';
import { ScrollerModule } from 'prime-ng-old/scroller';
import { ArrowDownIcon } from 'prime-ng-old/icons/arrowdown';
import { ArrowUpIcon } from 'prime-ng-old/icons/arrowup';
import { SpinnerIcon } from 'prime-ng-old/icons/spinner';
import { TableBody } from './table-body';
import * as i0 from "@angular/core";
import * as i1 from "./service";
import * as i2 from "prime-ng-old/api";
import * as i3 from "@angular/platform-browser";
import * as i4 from "@angular/common";
import * as i5 from "prime-ng-old/scroller";
import * as i6 from "primeng/api";
import * as i7 from "../paginator/paginator";
const _c0 = (a0, a1, a2, a3) => ({
  "p-datatable p-component": true,
  "p-datatable-hoverable-rows": a0,
  "p-datatable-scrollable": a1,
  "p-datatable-flex-scrollable": a2,
  "p-datatable-selectable-rows": a3
});
const _c1 = a0 => ({
  maxHeight: a0
});
const _c2 = a0 => ({
  height: a0
});
const _c3 = (a0, a1) => ({
  $implicit: a0,
  options: a1
});
const _c4 = a0 => ({
  columns: a0
});
const _c5 = (a0, a1, a2) => ({
  "p-datatable-table": true,
  "p-datatable-scrollable-table": a0,
  "p-datatable-resizable-table": a1,
  "p-datatable-resizable-table-fit": a2
});
const _c6 = a0 => ({
  $implicit: a0
});
function UiTableComponent_Conditional_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap("p-datatable-loading-icon " + ctx_r0.loadingIcon);
  }
}
function UiTableComponent_Conditional_2_Conditional_2_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "SpinnerIcon", 21);
  }
  if (rf & 2) {
    i0.ɵɵproperty("spin", true)("styleClass", "p-datatable-loading-icon");
  }
}
function UiTableComponent_Conditional_2_Conditional_2_Conditional_1_1_ng_template_0_Template(rf, ctx) {}
function UiTableComponent_Conditional_2_Conditional_2_Conditional_1_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiTableComponent_Conditional_2_Conditional_2_Conditional_1_1_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function UiTableComponent_Conditional_2_Conditional_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 22);
    i0.ɵɵtemplate(1, UiTableComponent_Conditional_2_Conditional_2_Conditional_1_1_Template, 1, 0, null, 23);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.loadingIconTemplate);
  }
}
function UiTableComponent_Conditional_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, UiTableComponent_Conditional_2_Conditional_2_Conditional_0_Template, 1, 2, "SpinnerIcon", 21);
    i0.ɵɵconditionalCreate(1, UiTableComponent_Conditional_2_Conditional_2_Conditional_1_Template, 2, 1, "span", 22);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(!ctx_r0.loadingIconTemplate ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.loadingIconTemplate ? 1 : -1);
  }
}
function UiTableComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵconditionalCreate(1, UiTableComponent_Conditional_2_Conditional_1_Template, 1, 2, "i", 20);
    i0.ɵɵconditionalCreate(2, UiTableComponent_Conditional_2_Conditional_2_Template, 2, 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.loadingIcon ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r0.loadingIcon ? 2 : -1);
  }
}
function UiTableComponent_Conditional_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiTableComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵtemplate(1, UiTableComponent_Conditional_3_ng_container_1_Template, 1, 0, "ng-container", 23);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.captionTemplate);
  }
}
function UiTableComponent_Conditional_4_Conditional_1_ng_template_0_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiTableComponent_Conditional_4_Conditional_1_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiTableComponent_Conditional_4_Conditional_1_ng_template_0_ng_container_0_Template, 1, 0, "ng-container", 23);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.paginatorDropdownIconTemplate);
  }
}
function UiTableComponent_Conditional_4_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiTableComponent_Conditional_4_Conditional_1_ng_template_0_Template, 1, 1, "ng-template", 25);
  }
}
function UiTableComponent_Conditional_4_Conditional_2_ng_template_0_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiTableComponent_Conditional_4_Conditional_2_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiTableComponent_Conditional_4_Conditional_2_ng_template_0_ng_container_0_Template, 1, 0, "ng-container", 23);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.paginatorFirstPageLinkIconTemplate);
  }
}
function UiTableComponent_Conditional_4_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiTableComponent_Conditional_4_Conditional_2_ng_template_0_Template, 1, 1, "ng-template", 26);
  }
}
function UiTableComponent_Conditional_4_Conditional_3_ng_template_0_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiTableComponent_Conditional_4_Conditional_3_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiTableComponent_Conditional_4_Conditional_3_ng_template_0_ng_container_0_Template, 1, 0, "ng-container", 23);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.paginatorPreviousPageLinkIconTemplate);
  }
}
function UiTableComponent_Conditional_4_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiTableComponent_Conditional_4_Conditional_3_ng_template_0_Template, 1, 1, "ng-template", 27);
  }
}
function UiTableComponent_Conditional_4_Conditional_4_ng_template_0_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiTableComponent_Conditional_4_Conditional_4_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiTableComponent_Conditional_4_Conditional_4_ng_template_0_ng_container_0_Template, 1, 0, "ng-container", 23);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.paginatorLastPageLinkIconTemplate);
  }
}
function UiTableComponent_Conditional_4_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiTableComponent_Conditional_4_Conditional_4_ng_template_0_Template, 1, 1, "ng-template", 28);
  }
}
function UiTableComponent_Conditional_4_Conditional_5_ng_template_0_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiTableComponent_Conditional_4_Conditional_5_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiTableComponent_Conditional_4_Conditional_5_ng_template_0_ng_container_0_Template, 1, 0, "ng-container", 23);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.paginatorNextPageLinkIconTemplate);
  }
}
function UiTableComponent_Conditional_4_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiTableComponent_Conditional_4_Conditional_5_ng_template_0_Template, 1, 1, "ng-template", 29);
  }
}
function UiTableComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ui-paginator", 24);
    i0.ɵɵlistener("onPageChange", function UiTableComponent_Conditional_4_Template_ui_paginator_onPageChange_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onPageChange($event));
    });
    i0.ɵɵconditionalCreate(1, UiTableComponent_Conditional_4_Conditional_1_Template, 1, 0, null, 25);
    i0.ɵɵconditionalCreate(2, UiTableComponent_Conditional_4_Conditional_2_Template, 1, 0, null, 26);
    i0.ɵɵconditionalCreate(3, UiTableComponent_Conditional_4_Conditional_3_Template, 1, 0, null, 27);
    i0.ɵɵconditionalCreate(4, UiTableComponent_Conditional_4_Conditional_4_Template, 1, 0, null, 28);
    i0.ɵɵconditionalCreate(5, UiTableComponent_Conditional_4_Conditional_5_Template, 1, 0, null, 29);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("rows", ctx_r0.rows)("first", ctx_r0.first)("totalRecords", ctx_r0.totalRecords)("pageLinkSize", ctx_r0.pageLinks)("alwaysShow", ctx_r0.alwaysShowPaginator)("rowsPerPageOptions", ctx_r0.rowsPerPageOptions)("templateLeft", ctx_r0.paginatorLeftTemplate)("templateRight", ctx_r0.paginatorRightTemplate)("dropdownAppendTo", ctx_r0.paginatorDropdownAppendTo)("dropdownScrollHeight", ctx_r0.paginatorDropdownScrollHeight)("currentPageReportTemplate", ctx_r0.currentPageReportTemplate)("showFirstLastIcon", ctx_r0.showFirstLastIcon)("dropdownItemTemplate", ctx_r0.paginatorDropdownItemTemplate)("showCurrentPageReport", ctx_r0.showCurrentPageReport)("showJumpToPageDropdown", ctx_r0.showJumpToPageDropdown)("showJumpToPageInput", ctx_r0.showJumpToPageInput)("showPageLinks", ctx_r0.showPageLinks)("styleClass", ctx_r0.getPaginatorStyleClasses("p-paginator-top"))("locale", ctx_r0.paginatorLocale);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.paginatorDropdownIconTemplate ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.paginatorFirstPageLinkIconTemplate ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.paginatorPreviousPageLinkIconTemplate ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.paginatorLastPageLinkIconTemplate ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.paginatorNextPageLinkIconTemplate ? 5 : -1);
  }
}
function UiTableComponent_Conditional_7_ng_template_2_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiTableComponent_Conditional_7_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiTableComponent_Conditional_7_ng_template_2_ng_container_0_Template, 1, 0, "ng-container", 32);
  }
  if (rf & 2) {
    const items_r4 = ctx.$implicit;
    const scrollerOptions_r5 = ctx.options;
    i0.ɵɵnextContext(2);
    const buildInTable_r6 = i0.ɵɵreference(10);
    i0.ɵɵproperty("ngTemplateOutlet", buildInTable_r6)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c3, items_r4, scrollerOptions_r5));
  }
}
function UiTableComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-scroller", 30, 3);
    i0.ɵɵlistener("onLazyLoad", function UiTableComponent_Conditional_7_Template_p_scroller_onLazyLoad_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onLazyItemLoad($event));
    });
    i0.ɵɵtemplate(2, UiTableComponent_Conditional_7_ng_template_2_Template, 1, 5, "ng-template", 31);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵstyleMap(i0.ɵɵpureFunction1(15, _c2, ctx_r0.scrollHeight !== "flex" ? ctx_r0.scrollHeight : undefined));
    i0.ɵɵproperty("items", ctx_r0.processedData)("columns", ctx_r0.columns)("scrollHeight", ctx_r0.scrollHeight !== "flex" ? undefined : "100%")("itemSize", ctx_r0.virtualScrollItemSize || ctx_r0._virtualRowHeight)("step", ctx_r0.rows)("delay", ctx_r0.lazy ? ctx_r0.virtualScrollDelay : 0)("inline", true)("lazy", ctx_r0.lazy)("loaderDisabled", true)("showSpacer", false)("showLoader", ctx_r0.loadingBodyTemplate)("options", ctx_r0.virtualScrollOptions)("autoSize", true);
  }
}
function UiTableComponent_Conditional_8_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiTableComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiTableComponent_Conditional_8_ng_container_0_Template, 1, 0, "ng-container", 32);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const buildInTable_r6 = i0.ɵɵreference(10);
    i0.ɵɵproperty("ngTemplateOutlet", buildInTable_r6)("ngTemplateOutletContext", i0.ɵɵpureFunction2(4, _c3, ctx_r0.processedData, i0.ɵɵpureFunction1(2, _c4, ctx_r0.columns)));
  }
}
function UiTableComponent_ng_template_9_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiTableComponent_ng_template_9_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiTableComponent_ng_template_9_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "tbody", 35);
  }
  if (rf & 2) {
    const scrollerOptions_r7 = i0.ɵɵnextContext().options;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("value", ctx_r0.frozenValue)("frozenRows", true)("pTableBody", scrollerOptions_r7.columns)("pTableBodyTemplate", ctx_r0.frozenBodyTemplate)("frozen", true);
  }
}
function UiTableComponent_ng_template_9_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "tbody", 39);
  }
  if (rf & 2) {
    const scrollerOptions_r7 = i0.ɵɵnextContext().options;
    i0.ɵɵstyleMap("height: calc(" + scrollerOptions_r7.spacerStyle.height + " - " + scrollerOptions_r7.rows.length * scrollerOptions_r7.itemSize + "px);");
  }
}
function UiTableComponent_ng_template_9_Conditional_9_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiTableComponent_ng_template_9_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tfoot", 38, 6);
    i0.ɵɵtemplate(2, UiTableComponent_ng_template_9_Conditional_9_ng_container_2_Template, 1, 0, "ng-container", 32);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const scrollerOptions_r7 = i0.ɵɵnextContext().options;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.footerGroupedTemplate || ctx_r0.footerTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c6, scrollerOptions_r7.columns));
  }
}
function UiTableComponent_ng_template_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "table", 33, 4);
    i0.ɵɵtemplate(2, UiTableComponent_ng_template_9_ng_container_2_Template, 1, 0, "ng-container", 32);
    i0.ɵɵelementStart(3, "thead", 34, 5);
    i0.ɵɵtemplate(5, UiTableComponent_ng_template_9_ng_container_5_Template, 1, 0, "ng-container", 32);
    i0.ɵɵelementEnd();
    i0.ɵɵconditionalCreate(6, UiTableComponent_ng_template_9_Conditional_6_Template, 1, 5, "tbody", 35);
    i0.ɵɵelement(7, "tbody", 36);
    i0.ɵɵconditionalCreate(8, UiTableComponent_ng_template_9_Conditional_8_Template, 1, 2, "tbody", 37);
    i0.ɵɵconditionalCreate(9, UiTableComponent_ng_template_9_Conditional_9_Template, 3, 4, "tfoot", 38);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const scrollerOptions_r7 = ctx.options;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵstyleMap(ctx_r0.tableStyle);
    i0.ɵɵclassMap(ctx_r0.tableStyleClass);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(20, _c5, ctx_r0.scrollable, ctx_r0.resizableColumns, ctx_r0.resizableColumns && ctx_r0.columnResizeMode === "fit"));
    i0.ɵɵattribute("id", ctx_r0.id + "-table");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.colGroupTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(24, _c6, scrollerOptions_r7.columns));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.headerGroupedTemplate || ctx_r0.headerTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(26, _c6, scrollerOptions_r7.columns));
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.frozenValue || ctx_r0.frozenBodyTemplate ? 6 : -1);
    i0.ɵɵadvance();
    i0.ɵɵstyleMap(scrollerOptions_r7.contentStyle);
    i0.ɵɵproperty("ngClass", scrollerOptions_r7.contentStyleClass)("value", ctx_r0.dataToRender(scrollerOptions_r7.rows))("pTableBody", scrollerOptions_r7.columns)("pTableBodyTemplate", ctx_r0.bodyTemplate)("scrollerOptions", scrollerOptions_r7);
    i0.ɵɵadvance();
    i0.ɵɵconditional(scrollerOptions_r7.spacerStyle ? 8 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.footerGroupedTemplate || ctx_r0.footerTemplate ? 9 : -1);
  }
}
function UiTableComponent_Conditional_11_Conditional_1_ng_template_0_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiTableComponent_Conditional_11_Conditional_1_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiTableComponent_Conditional_11_Conditional_1_ng_template_0_ng_container_0_Template, 1, 0, "ng-container", 23);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.paginatorDropdownIconTemplate);
  }
}
function UiTableComponent_Conditional_11_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiTableComponent_Conditional_11_Conditional_1_ng_template_0_Template, 1, 1, "ng-template", 25);
  }
}
function UiTableComponent_Conditional_11_Conditional_2_ng_template_0_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiTableComponent_Conditional_11_Conditional_2_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiTableComponent_Conditional_11_Conditional_2_ng_template_0_ng_container_0_Template, 1, 0, "ng-container", 23);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.paginatorFirstPageLinkIconTemplate);
  }
}
function UiTableComponent_Conditional_11_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiTableComponent_Conditional_11_Conditional_2_ng_template_0_Template, 1, 1, "ng-template", 26);
  }
}
function UiTableComponent_Conditional_11_Conditional_3_ng_template_0_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiTableComponent_Conditional_11_Conditional_3_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiTableComponent_Conditional_11_Conditional_3_ng_template_0_ng_container_0_Template, 1, 0, "ng-container", 23);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.paginatorPreviousPageLinkIconTemplate);
  }
}
function UiTableComponent_Conditional_11_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiTableComponent_Conditional_11_Conditional_3_ng_template_0_Template, 1, 1, "ng-template", 27);
  }
}
function UiTableComponent_Conditional_11_Conditional_4_ng_template_0_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiTableComponent_Conditional_11_Conditional_4_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiTableComponent_Conditional_11_Conditional_4_ng_template_0_ng_container_0_Template, 1, 0, "ng-container", 23);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.paginatorLastPageLinkIconTemplate);
  }
}
function UiTableComponent_Conditional_11_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiTableComponent_Conditional_11_Conditional_4_ng_template_0_Template, 1, 1, "ng-template", 28);
  }
}
function UiTableComponent_Conditional_11_Conditional_5_ng_template_0_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiTableComponent_Conditional_11_Conditional_5_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiTableComponent_Conditional_11_Conditional_5_ng_template_0_ng_container_0_Template, 1, 0, "ng-container", 23);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.paginatorNextPageLinkIconTemplate);
  }
}
function UiTableComponent_Conditional_11_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiTableComponent_Conditional_11_Conditional_5_ng_template_0_Template, 1, 1, "ng-template", 29);
  }
}
function UiTableComponent_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ui-paginator", 24);
    i0.ɵɵlistener("onPageChange", function UiTableComponent_Conditional_11_Template_ui_paginator_onPageChange_0_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onPageChange($event));
    });
    i0.ɵɵconditionalCreate(1, UiTableComponent_Conditional_11_Conditional_1_Template, 1, 0, null, 25);
    i0.ɵɵconditionalCreate(2, UiTableComponent_Conditional_11_Conditional_2_Template, 1, 0, null, 26);
    i0.ɵɵconditionalCreate(3, UiTableComponent_Conditional_11_Conditional_3_Template, 1, 0, null, 27);
    i0.ɵɵconditionalCreate(4, UiTableComponent_Conditional_11_Conditional_4_Template, 1, 0, null, 28);
    i0.ɵɵconditionalCreate(5, UiTableComponent_Conditional_11_Conditional_5_Template, 1, 0, null, 29);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("rows", ctx_r0.rows)("first", ctx_r0.first)("totalRecords", ctx_r0.totalRecords)("pageLinkSize", ctx_r0.pageLinks)("alwaysShow", ctx_r0.alwaysShowPaginator)("rowsPerPageOptions", ctx_r0.rowsPerPageOptions)("templateLeft", ctx_r0.paginatorLeftTemplate)("templateRight", ctx_r0.paginatorRightTemplate)("dropdownAppendTo", ctx_r0.paginatorDropdownAppendTo)("dropdownScrollHeight", ctx_r0.paginatorDropdownScrollHeight)("currentPageReportTemplate", ctx_r0.currentPageReportTemplate)("showFirstLastIcon", ctx_r0.showFirstLastIcon)("dropdownItemTemplate", ctx_r0.paginatorDropdownItemTemplate)("showCurrentPageReport", ctx_r0.showCurrentPageReport)("showJumpToPageDropdown", ctx_r0.showJumpToPageDropdown)("showJumpToPageInput", ctx_r0.showJumpToPageInput)("showPageLinks", ctx_r0.showPageLinks)("styleClass", ctx_r0.getPaginatorStyleClasses("p-paginator-bottom"))("locale", ctx_r0.paginatorLocale);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.paginatorDropdownIconTemplate ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.paginatorFirstPageLinkIconTemplate ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.paginatorPreviousPageLinkIconTemplate ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.paginatorLastPageLinkIconTemplate ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.paginatorNextPageLinkIconTemplate ? 5 : -1);
  }
}
function UiTableComponent_Conditional_12_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiTableComponent_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtemplate(1, UiTableComponent_Conditional_12_ng_container_1_Template, 1, 0, "ng-container", 23);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.summaryTemplate);
  }
}
function UiTableComponent_Conditional_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 17, 7);
  }
}
function UiTableComponent_Conditional_14_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ArrowDownIcon");
  }
}
function UiTableComponent_Conditional_14_3_ng_template_0_Template(rf, ctx) {}
function UiTableComponent_Conditional_14_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiTableComponent_Conditional_14_3_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function UiTableComponent_Conditional_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 18, 8);
    i0.ɵɵconditionalCreate(2, UiTableComponent_Conditional_14_Conditional_2_Template, 1, 0, "ArrowDownIcon");
    i0.ɵɵtemplate(3, UiTableComponent_Conditional_14_3_Template, 1, 0, null, 23);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(!ctx_r0.reorderIndicatorUpIconTemplate ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.reorderIndicatorUpIconTemplate);
  }
}
function UiTableComponent_Conditional_15_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ArrowUpIcon");
  }
}
function UiTableComponent_Conditional_15_3_ng_template_0_Template(rf, ctx) {}
function UiTableComponent_Conditional_15_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiTableComponent_Conditional_15_3_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function UiTableComponent_Conditional_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 19, 9);
    i0.ɵɵconditionalCreate(2, UiTableComponent_Conditional_15_Conditional_2_Template, 1, 0, "ArrowUpIcon");
    i0.ɵɵtemplate(3, UiTableComponent_Conditional_15_3_Template, 1, 0, null, 23);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(!ctx_r0.reorderIndicatorDownIconTemplate ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.reorderIndicatorDownIconTemplate);
  }
}
export let UiTableComponent = /*#__PURE__*/(() => {
  class UiTableComponent extends TableBase {
    constructor(document, platformId, renderer, el, zone, tableService, cd, filterService, overlayService, config, domSanitizer) {
      super(document, platformId, renderer, el, zone, tableService, cd, filterService, overlayService, config);
      this.el = el;
      this.zone = zone;
      this.tableService = tableService;
      this.cd = cd;
      this.filterService = filterService;
      this.overlayService = overlayService;
      this.config = config;
      this.rowHover = true;
      this.selectionMode = "single";
      this.stateExcludedProps = [];
      this.currentPageReportTemplate = "Zeige Items {first} bis {last}, insgesamt {totalRecords}";
    }
    setPage(index) {
      console.log('update table paginator page to ' + index);
      this.first = index * this.rows;
    }
    saveState() {
      const storage = this.getStorage();
      const state = {};
      if (this.paginator && !this.stateExcludedProps.includes('paginator')) {
        state.first = this.first;
        state.rows = this.rows;
      }
      if (this.sortField && !this.stateExcludedProps.includes('sortField')) {
        state.sortField = this.sortField;
        state.sortOrder = this.sortOrder;
      }
      if (this.multiSortMeta && !this.stateExcludedProps.includes('multiSortMeta')) {
        state.multiSortMeta = this.multiSortMeta;
      }
      if (this.hasFilter() && !this.stateExcludedProps.includes('filters')) {
        state.filters = this.filters;
      }
      if (this.resizableColumns && !this.stateExcludedProps.includes('resizableColumns')) {
        this.saveColumnWidths(state);
      }
      if (this.reorderableColumns && !this.stateExcludedProps.includes('reorderableColumns')) {
        this.saveColumnOrder(state);
      }
      if (this.selection && !this.stateExcludedProps.includes('selection')) {
        state.selection = this.selection;
      }
      if (Object.keys(this.expandedRowKeys).length && !this.stateExcludedProps.includes('expandedRowKeys')) {
        state.expandedRowKeys = this.expandedRowKeys;
      }
      storage.setItem(this.stateKey, JSON.stringify(state));
      this.onStateSave.emit(state);
    }
    // a simplified custom version of handleRowRightClick, + better naming. used by custom contextmenu directives.
    handleContextMenu(event) {
      if (this.contextMenu) {
        if (!(this.contextMenu instanceof UiMenuComponent)) throw new Error('our custom contextMenu logic currently only works with out ui-menu component. Implement further support as needed.');
        const rowData = event.rowData;
        this.contextMenuSelection = rowData;
        this.contextMenuSelectionChange.emit(rowData);
        this.onContextMenuSelect.emit({
          originalEvent: event.originalEvent,
          data: rowData,
          index: event.rowIndex
        });
        this.contextMenu.show(event.originalEvent, event.atCursor || false);
        this.contextMenu.onHide.pipe(take(1)).subscribe(() => {
          // important to clear contextMenuSelection as it will switch handleRowClick functionality.
          this.contextMenuSelection = null;
        });
        this.tableService.onContextMenu(rowData);
      }
    }
    handleRowRightClick(event) {
      this.handleContextMenu(event);
    }
    handleRowClick(event) {
      if (this.contextMenuSelection) {
        this.contextMenu?.hide();
        this.contextMenuSelection = null;
      } else {
        super.handleRowClick(event);
      }
    }
    static {
      this.ɵfac = function UiTableComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UiTableComponent)(i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(PLATFORM_ID), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i1.TableService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i2.FilterService), i0.ɵɵdirectiveInject(i2.OverlayService), i0.ɵɵdirectiveInject(i2.PrimeNGConfig), i0.ɵɵdirectiveInject(i3.DomSanitizer));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: UiTableComponent,
        selectors: [["ui-table"]],
        contentQueries: function UiTableComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, UiTemplateDirective, 4);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templates = _t);
          }
        },
        inputs: {
          rowHover: "rowHover",
          selectionMode: "selectionMode",
          stateExcludedProps: "stateExcludedProps",
          currentPageReportTemplate: "currentPageReportTemplate",
          contextMenu: "contextMenu"
        },
        features: [i0.ɵɵProvidersFeature([TableService, {
          provide: PARENT_TABLE,
          useExisting: UiTableComponent
        }]), i0.ɵɵInheritDefinitionFeature],
        decls: 16,
        vars: 23,
        consts: [["container", ""], ["wrapper", ""], ["buildInTable", ""], ["scroller", ""], ["table", ""], ["thead", ""], ["tfoot", ""], ["resizeHelper", ""], ["reorderIndicatorUp", ""], ["reorderIndicatorDown", ""], [3, "ngStyle", "ngClass"], [1, "p-datatable-loading-overlay", "p-component-overlay"], [1, "p-datatable-header"], [3, "rows", "first", "totalRecords", "pageLinkSize", "alwaysShow", "rowsPerPageOptions", "templateLeft", "templateRight", "dropdownAppendTo", "dropdownScrollHeight", "currentPageReportTemplate", "showFirstLastIcon", "dropdownItemTemplate", "showCurrentPageReport", "showJumpToPageDropdown", "showJumpToPageInput", "showPageLinks", "styleClass", "locale"], [1, "p-datatable-wrapper", 3, "ngStyle"], [3, "items", "columns", "style", "scrollHeight", "itemSize", "step", "delay", "inline", "lazy", "loaderDisabled", "showSpacer", "showLoader", "options", "autoSize"], [1, "p-datatable-footer"], [1, "p-column-resizer-helper", 2, "display", "none"], [1, "p-datatable-reorder-indicator-up", 2, "display", "none"], [1, "p-datatable-reorder-indicator-down", 2, "display", "none"], [3, "class"], [3, "spin", "styleClass"], [1, "p-datatable-loading-icon"], [4, "ngTemplateOutlet"], [3, "onPageChange", "rows", "first", "totalRecords", "pageLinkSize", "alwaysShow", "rowsPerPageOptions", "templateLeft", "templateRight", "dropdownAppendTo", "dropdownScrollHeight", "currentPageReportTemplate", "showFirstLastIcon", "dropdownItemTemplate", "showCurrentPageReport", "showJumpToPageDropdown", "showJumpToPageInput", "showPageLinks", "styleClass", "locale"], ["pTemplate", "dropdownicon"], ["pTemplate", "firstpagelinkicon"], ["pTemplate", "previouspagelinkicon"], ["pTemplate", "lastpagelinkicon"], ["pTemplate", "nextpagelinkicon"], [3, "onLazyLoad", "items", "columns", "scrollHeight", "itemSize", "step", "delay", "inline", "lazy", "loaderDisabled", "showSpacer", "showLoader", "options", "autoSize"], ["pTemplate", "content"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["role", "table", 3, "ngClass"], ["role", "rowgroup", 1, "p-datatable-thead"], ["role", "rowgroup", 1, "p-datatable-tbody", "p-datatable-frozen-tbody", 3, "value", "frozenRows", "pTableBody", "pTableBodyTemplate", "frozen"], ["role", "rowgroup", 1, "p-datatable-tbody", 3, "ngClass", "value", "pTableBody", "pTableBodyTemplate", "scrollerOptions"], ["role", "rowgroup", 1, "p-datatable-scroller-spacer", 3, "style"], ["role", "rowgroup", 1, "p-datatable-tfoot"], ["role", "rowgroup", 1, "p-datatable-scroller-spacer"]],
        template: function UiTableComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 10, 0);
            i0.ɵɵconditionalCreate(2, UiTableComponent_Conditional_2_Template, 3, 2, "div", 11);
            i0.ɵɵconditionalCreate(3, UiTableComponent_Conditional_3_Template, 2, 1, "div", 12);
            i0.ɵɵconditionalCreate(4, UiTableComponent_Conditional_4_Template, 6, 24, "ui-paginator", 13);
            i0.ɵɵelementStart(5, "div", 14, 1);
            i0.ɵɵconditionalCreate(7, UiTableComponent_Conditional_7_Template, 3, 17, "p-scroller", 15);
            i0.ɵɵconditionalCreate(8, UiTableComponent_Conditional_8_Template, 1, 7, "ng-container");
            i0.ɵɵtemplate(9, UiTableComponent_ng_template_9_Template, 10, 28, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementEnd();
            i0.ɵɵconditionalCreate(11, UiTableComponent_Conditional_11_Template, 6, 24, "ui-paginator", 13);
            i0.ɵɵconditionalCreate(12, UiTableComponent_Conditional_12_Template, 2, 1, "div", 16);
            i0.ɵɵconditionalCreate(13, UiTableComponent_Conditional_13_Template, 2, 0, "div", 17);
            i0.ɵɵconditionalCreate(14, UiTableComponent_Conditional_14_Template, 4, 2, "span", 18);
            i0.ɵɵconditionalCreate(15, UiTableComponent_Conditional_15_Template, 4, 2, "span", 19);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵclassMap(ctx.styleClass);
            i0.ɵɵproperty("ngStyle", ctx.style)("ngClass", i0.ɵɵpureFunction4(16, _c0, ctx.rowHover || ctx.selectionMode, ctx.scrollable, ctx.scrollable && ctx.scrollHeight === "flex", !!ctx.selectionMode));
            i0.ɵɵattribute("id", ctx.id);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.loading && ctx.showLoader ? 2 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.captionTemplate ? 3 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.paginator && (ctx.paginatorPosition === "top" || ctx.paginatorPosition == "both") ? 4 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(21, _c1, ctx.virtualScroll ? "" : ctx.scrollHeight));
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.virtualScroll ? 7 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.virtualScroll ? 8 : -1);
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(ctx.paginator && (ctx.paginatorPosition === "bottom" || ctx.paginatorPosition == "both") ? 11 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.summaryTemplate ? 12 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.resizableColumns ? 13 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.reorderableColumns ? 14 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.reorderableColumns ? 15 : -1);
          }
        },
        dependencies: [CommonModule, i4.NgClass, i4.NgTemplateOutlet, i4.NgStyle, ScrollerModule, i5.Scroller, i6.PrimeTemplate, FormsModule, i7.UiPaginatorComponent,
        // TODO: these are direct primeNG imports because these components are not being used anywhere else. Should be updated if customized ui versions are being created.
        InputNumberModule, ArrowDownIcon, ArrowUpIcon, SpinnerIcon, TableBody],
        styles: ["@layer primeng{.p-datatable{position:relative}.p-datatable>.p-datatable-wrapper{overflow:auto}.p-datatable-table{border-spacing:0px;width:100%}.p-datatable .p-sortable-column{cursor:pointer;-webkit-user-select:none;user-select:none}.p-datatable .p-sortable-column .p-column-title,.p-datatable .p-sortable-column .p-sortable-column-icon,.p-datatable .p-sortable-column .p-sortable-column-badge{vertical-align:middle}.p-datatable .p-sortable-column .p-icon-wrapper{display:inline}.p-datatable .p-sortable-column .p-sortable-column-badge{display:inline-flex;align-items:center;justify-content:center}.p-datatable-hoverable-rows .p-selectable-row{cursor:pointer}.p-datatable-scrollable>.p-datatable-wrapper{position:relative}.p-datatable-scrollable-table>.p-datatable-thead{position:sticky;top:0;z-index:2}.p-datatable-scrollable-table>.p-datatable-frozen-tbody{position:sticky;z-index:1}.p-datatable-scrollable-table>.p-datatable-tfoot{position:sticky;bottom:0;z-index:1}.p-datatable-scrollable .p-frozen-column{position:sticky;background:inherit;z-index:1}.p-datatable-scrollable th.p-frozen-column{z-index:1}.p-datatable-flex-scrollable{display:flex;flex-direction:column;height:100%}.p-datatable-flex-scrollable>.p-datatable-wrapper{display:flex;flex-direction:column;flex:1;height:100%}.p-datatable-scrollable-table>.p-datatable-tbody>.p-rowgroup-header{position:sticky;z-index:2}.p-datatable-resizable-table>.p-datatable-thead>tr>th,.p-datatable-resizable-table>.p-datatable-tfoot>tr>td,.p-datatable-resizable-table>.p-datatable-tbody>tr>td{overflow:hidden;white-space:nowrap}.p-datatable-resizable-table>.p-datatable-thead>tr>th.p-resizable-column:not(.p-frozen-column){background-clip:padding-box;position:relative}.p-datatable-resizable-table-fit>.p-datatable-thead>tr>th.p-resizable-column:last-child .p-column-resizer{display:none}.p-datatable .p-column-resizer{display:block;position:absolute!important;top:0;right:0;margin:0;width:.5rem;height:100%;padding:0;cursor:col-resize;border:1px solid transparent}.p-datatable .p-column-resizer-helper{width:1px;position:absolute;z-index:10;display:none}.p-datatable .p-row-editor-init,.p-datatable .p-row-editor-save,.p-datatable .p-row-editor-cancel,.p-datatable .p-row-toggler{display:inline-flex;align-items:center;justify-content:center;overflow:hidden;position:relative}.p-datatable-reorder-indicator-up,.p-datatable-reorder-indicator-down{position:absolute}.p-datatable-reorderablerow-handle,[pReorderableColumn]{cursor:move}.p-datatable .p-datatable-loading-overlay{position:absolute;display:flex;align-items:center;justify-content:center;z-index:3}.p-column-filter-row{display:flex;align-items:center;width:100%}.p-column-filter-menu{display:inline-flex}.p-column-filter-row p-columnfilterformelement{flex:1 1 auto;width:1%}.p-column-filter-menu-button,.p-column-filter-clear-button{display:inline-flex;justify-content:center;align-items:center;cursor:pointer;text-decoration:none;overflow:hidden;position:relative}.p-column-filter-overlay{position:absolute;top:0;left:0}.p-column-filter-row-items{margin:0;padding:0;list-style:none}.p-column-filter-row-item{cursor:pointer}.p-column-filter-add-button,.p-column-filter-remove-button{justify-content:center}.p-column-filter-add-button .p-button-label,.p-column-filter-remove-button .p-button-label{flex-grow:0}.p-column-filter-buttonbar{display:flex;align-items:center;justify-content:space-between}.p-column-filter-buttonbar .p-button{width:auto}.p-datatable-tbody>tr>td>.p-column-title{display:none}.p-datatable-scroller-spacer{display:flex}.p-datatable .p-scroller .p-scroller-loading{transform:none!important;min-height:0;position:sticky;top:0;left:0}}.p-datatable .p-datatable-loading-overlay{position:absolute!important}.p-datatable .p-datatable-caption,.p-datatable .p-datatable-summary{background-color:var(--panelHeaderBgColor);color:var(--panelHeaderTextColor);border:0;border-color:var(--panelHeaderBorderColor);padding:8px 10px;font-weight:400;text-align:center}.p-datatable .p-datatable-caption{border-bottom:0 none}.p-datatable .p-datatable-summary{border-top:0 none}.p-datatable .p-datatable-thead>tr>th{padding:6px 6px 3px;border:none;border-color:var(--tableHeaderCellBorderColor);font-weight:300;text-transform:uppercase;font-size:14px;color:var(--tableHeaderCellTextColor);background-color:var(--tableHeaderCellBgColor);text-align:left;transition:background-color .2s,color .2s,border-color .2s}.p-datatable .p-datatable-tbody:before{content:\"@\";display:table-row;visibility:hidden;line-height:10px;text-indent:-99999px}.p-datatable .p-datatable-tbody>tr>td{padding:5px 6px}.p-datatable .p-datatable-tfoot>tr>td{padding:8px 6px;border:1px solid #c8c8c8;border-color:var(--tableFooterCellBorderColor);font-weight:300;color:var(--tableFooterCellTextColor);background-color:var(--tableFooterCellBgColor)}.p-datatable .p-sortable-column{border-radius:4px}body.a11y-highlight-interactible .p-datatable .p-sortable-column{outline:var(--a11yInteractibleElementOutline)!important;outline-offset:var(--a11yInteractibleElementOutlineOffset)!important;outline-color:var(--a11yInteractibleElementOutlineColor)!important}.p-datatable .p-sortable-column:focus{background-color:var(--focusColor)!important;border-color:var(--focusColor)!important}.p-datatable .p-sortable-column .p-sortable-column-icon{color:var(--tableHeaderCellTextColor);font-size:12px}.p-datatable .p-sortable-column:not(.p-highlight):hover{background-color:var(--tableHeaderCellHoverBgColor);color:var(--tableHeaderCellHoverTextColor)}.p-datatable .p-sortable-column:not(.p-highlight):hover .p-sortable-column-icon{color:var(--tableHeaderCellHoverTextColor)}.p-datatable .p-sortable-column.p-highlight{background-color:var(--highlightBgColor);color:var(--highlightTextColor)}.p-datatable .p-sortable-column.p-highlight .p-sortable-column-icon{color:var(--highlightTextColor)}.p-datatable .p-datatable-tbody>tr{background:var(--tableBodyRowBgColor);color:var(--tableBodyRowTextColor)}.p-datatable .p-datatable-tbody>tr>td{background:inherit;border:none;border-color:var(--tableBodyCellBorderColor)}.p-datatable .p-datatable-tbody>tr.p-highlight{background-color:var(--highlightBgColor);color:var(--highlightTextColor)}.p-datatable .p-datatable-tbody>tr.p-contextmenu-selected{background-color:var(--highlightBgColor);color:var(--highlightTextColor)}body.a11y-highlight-interactible .p-datatable .p-datatable-tbody>tr.p-selectable-row{outline:var(--a11yInteractibleElementOutline)!important;outline-offset:var(--a11yInteractibleElementOutlineOffset)!important;outline-color:var(--a11yInteractibleElementOutlineColor)!important}.p-datatable .p-datatable-tbody>tr.p-selectable-row:focus{outline:var(--a11yFocusedElementOutline)!important;outline-offset:var(--a11yFocusedElementOutlineOffset)!important}.p-datatable .p-datatable-tbody>tr+tr td{border-top:1px solid var(--tableBodyCellBorderColor)}.p-datatable .p-datatable-tbody>tr:nth-child(2n){background-color:var(--tableBodyRowEvenBgColor)}.p-datatable .p-datatable-tbody>tr:nth-child(2n).p-state-highlight{background-color:var(--highlightBgColor);color:var(--highlightTextColor)}.p-datatable .p-datatable-tbody>tr:nth-child(2n).p-contextmenu-selected{background-color:var(--highlightBgColor);color:var(--highlightTextColor)}.p-datatable .p-datatable-tbody tr.expanded-row{background:var(--backgroundSoftColor)!important}.p-datatable .p-datatable-tbody tr.expanded-row>td>.margin{margin:20px 0}.p-datatable.p-datatable-hoverable-rows .p-datatable-tbody>tr{transition:background-color .2s}.p-datatable.p-datatable-hoverable-rows .p-datatable-tbody>tr:hover{background-color:var(--tableBodyRowHoverBgColor);color:var(--tableBodyRowHoverTextColor)}.p-datatable.p-datatable-selectable-rows .p-datatable-tbody>tr.p-selectable-row:not(.p-state-highlight):not(.p-contextmenu-selected):hover{cursor:pointer;background-color:var(--tableBodyClickableRowHoverBgColor);color:var(--tableBodyClickableRowHoverTextColor)}.p-datatable .p-column-resizer-helper{background-color:var(--tableResizerHelperBgColor)}@media screen and (max-width: 40em){.p-datatable.p-datatable-responsive .p-paginator-top{border-bottom:1px solid #c8c8c8;border-color:var(--paginatorBorderColor)}.p-datatable.p-datatable-responsive .p-paginator-bottom{border-top:1px solid #c8c8c8;border-color:var(--paginatorBorderColor)}.p-datatable.p-datatable-responsive .p-datatable-tbody>tr>td{border:0 none}}.p-datatable .p-datatable-tbody .p-datatable-reorderablerow-handle:hover{cursor:move}.p-datatable .p-datatable-tbody .p-datatable-reorderablerow-handle *{pointer-events:none}.p-datatable .p-datatable-tbody>tr.p-datatable-dragpoint-top>td{box-shadow:inset 0 2px 0 0 var(--dragPlaceholderBgColor)}.p-datatable .p-datatable-tbody>tr.p-datatable-dragpoint-bottom>td{box-shadow:inset 0 -2px 0 0 var(--dragPlaceholderBgColor)}.p-datatable-table.transparent{--tableHeaderCellBgColor:transparent!important;--tableFooterCellBgColor:transparent!important;--tableBodyRowBgColor:transparent!important;--tableBodyRowEvenBgColor:transparent!important}\n"],
        encapsulation: 2
      });
    }
  }
  return UiTableComponent;
})();